import { render, staticRenderFns } from "./MedicalSpecialities.vue?vue&type=template&id=09fd45fb"
import script from "./MedicalSpecialities.vue?vue&type=script&lang=js"
export * from "./MedicalSpecialities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports